import React from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import "./ApprovalWorkflow.css";

/**
 * Approval Workflow Tracker Component (Simplified - Single Leadership Review)
 * Displays visual stepper showing approval progress
 * Flow: Draft → Leadership Review → Completed
 */
const ApprovalWorkflowTracker = ({ currentStage, status, leadershipReviewCompleted }) => {
  
  // Determine stage descriptions based on approval state
  const getLeadershipReviewDescription = () => {
    if (currentStage === "LEADERSHIP_REVIEW" && leadershipReviewCompleted) {
      return "Approved by Leadership ✓";
    } else if (currentStage === "LEADERSHIP_REVIEW") {
      return "Awaiting ED or TLT approval";
    } else if (leadershipReviewCompleted) {
      return "Approved by Leadership";
    }
    return "Awaiting ED or TLT approval";
  };

  const stages = [
    { key: "DRAFT", label: "Draft", description: "Submitted by owner" },
    { key: "LEADERSHIP_REVIEW", label: "Leadership Review", description: getLeadershipReviewDescription() },
    { key: "COMPLETED", label: "Completed", description: "Report locked" },
  ];

  const getStageIndex = (stage) => {
    const index = stages.findIndex((s) => s.key === stage);
    return index >= 0 ? index : 0;
  };

  const currentIndex = getStageIndex(currentStage);

  const getStageState = (index) => {
    if (index < currentIndex) return "completed";
    if (index === currentIndex) {
      // If we are on the COMPLETED stage and it is the current stage, show it as completed (green)
      if (stages[index].key === "COMPLETED") return "completed";
      return "active";
    }
    return "pending";
  };

  return (
    <div className="approval-workflow-tracker">
      <div className="approval-workflow-header">
        <h3>APPROVAL WORKFLOW</h3>
        <span className="approval-stage-info">
          Stage {currentIndex + 1} of {stages.length}
        </span>
      </div>

      <div className="approval-workflow-steps">
        {stages.map((stage, index) => {
          const state = getStageState(index);
          return (
            <div key={stage.key} className={`approval-step approval-step--${state}`}>
              <div className="approval-step-indicator">
                {state === "completed" ? (
                  <div className="approval-step-icon approval-step-icon--completed">
                    <McIcon icon="check" size="small" />
                  </div>
                ) : (
                  <div className="approval-step-number">{index + 1}</div>
                )}
                {index < stages.length - 1 && <div className="approval-step-line" />}
              </div>
              <div className="approval-step-content">
                <div className="approval-step-label">{stage.label}</div>
                <div className="approval-step-description">{stage.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ApprovalWorkflowTracker;
